var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "notice"
  }, [_c('Icon', {
    staticClass: "circle_icon",
    attrs: {
      "type": "md-information-circle"
    }
  }), _vm.type === 'USER' ? _c('span', [_vm._v(` ${$t("l2j8m1d", "权限提示：当前标签只能选择")}`), _c('span', [_vm._v($t("h5542", "成员"))]), _vm._v(`${$t("qxfh3qa", "，不可选择部门，单位")} `)]) : _vm.type === 'ORG' ? _c('span', [_vm._v($t("l2j8m1d", "权限提示：当前标签只能选择")), _c('span', [_vm._v($t("pgxs2", "部门"))]), _vm._v($t("mfq6eqa", "，不可选择成员，单位"))]) : _c('span', [_vm._v($t("31wb6l5", "权限提示：")), _c('span', [_vm._v($t("bda6bs4", "均可选择"))])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };